import React from "react";
import logo from "../assets/logo.png";

const Logo = () => {
  return <img className="h-10" src={logo} alt="Company Logo" />;
};

export default Logo;
